module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Martin_VS-55b71e7d09b9041653613d5e2cc9afe3.png";